/**
 * Mutation pour l'import d'entrées via Excel (NOUVEAU).
 * Invalide les caches pour forcer le rafraîchissement.
 */
import { ApiMananger } from "actions/rtkquery";
import { INVALIDATE_CLIENT, INVALIDATE_PRODUITS, INVALIDATE_VENTES } from "../invalidationTags";

const importEntreeApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    importEntreesExcel: build.mutation({
      query: (formData) => ({
        url: "v1/entrees/import-excel/",
        method: "POST",
        body: formData,
      }),
      // Invalider les caches pour forcer le rafraîchissement (NOUVEAU)
      invalidatesTags: [
        INVALIDATE_VENTES,
        INVALIDATE_PRODUITS,
        INVALIDATE_CLIENT,
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useImportEntreesExcelMutation } = importEntreeApi;
